import { render } from "./ParentalControl.vue?vue&type=template&id=893467ca&scoped=true"
import script from "./ParentalControl.vue?vue&type=script&lang=js"
export * from "./ParentalControl.vue?vue&type=script&lang=js"

import "./ParentalControl.vue?vue&type=style&index=0&id=893467ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-893467ca"]])

export default __exports__